/**
 * Event handler that can subscribe to a dispatcher.
 */
import { IContributionRepository }                          from "@/pluginManager/contributionRepository";
import { IContributionRequestOptions }                      from "@/pluginManager/contributionRequestOptions";
import { IPortalPlugin }                                    from "@/pluginManager/IPortalPlugin";
import { PortalPluginEventDispatcher }                      from "@/pluginManager/portalPluginEventDispatcher";
import { ApiRoutes }                                        from "@/store/apiRoutes";
import { IContribution, IMedia }                            from "@/store/models";
import { IContributionResponse, ModerationState, Response } from "@/store/serverModels";
import Axios, { AxiosResponse }                             from "axios";

export type PortalPluginEventHandler<E> = (event: E) => void;

export class PluginManager implements IPortalPlugin {
  public contributionRepository: IContributionRepository;
  public dependencies: string[];
  public onContributionCreated: PortalPluginEventDispatcher<{ id: string }>;
  public onContributionModerated: PortalPluginEventDispatcher<{ id: string; newState: ModerationState }>;
  public onErrorOccured: PortalPluginEventDispatcher<{ id: number; message: string }>;
  public onUserAuthenticated: PortalPluginEventDispatcher<{ id: string }>;
  public onUserLoggedOut: PortalPluginEventDispatcher<{ id: string }>;
  private lastTimeChecked: number;
  private readonly _contributionId;
  public GetContributionId():string | undefined{
    return this._contributionId
  }


  constructor(public eventId: string, contributionId: string | undefined) {


    this._contributionId  = contributionId;
    this.lastTimeChecked = 0;
    this.contributionRepository  = new ContributionRepository(eventId);
    this.dependencies            = [];
    this.onContributionCreated   = new PortalPluginEventDispatcher<{ id: string }>();
    this.onContributionModerated = new PortalPluginEventDispatcher<{ id: string, newState: ModerationState }>();
    this.onErrorOccured          = new PortalPluginEventDispatcher<{ id: number, message: string }>();
    this.onUserAuthenticated     = new PortalPluginEventDispatcher<{ id: string }>();
    this.onUserLoggedOut         = new PortalPluginEventDispatcher<{ id: string }>();
      if(eventId!=="telekom" && eventId!=="bayer"){
          return;
      }
    setTimeout(this.checkForContribution, 1000, this);

  }

  public onStart(): () => void {
    return () => undefined;
  }

  private checkForContribution(context: PluginManager): void {
    Axios.get(ApiRoutes.Contribution.Count.replace("{eventId}", context.eventId) + "?since=" + context.lastTimeChecked).then(countResponse => {
      // console.log(countResponse.data);
      // console.log(context.contributionRepository.contributions.length)
      if (countResponse.data > 0) {
        Axios.get(ApiRoutes.Contribution.GetAll.replace("{eventId}", context.eventId) + "?since=" + context.lastTimeChecked).then((response: AxiosResponse<Response<IContributionResponse[]>>) => {
          context.lastTimeChecked = Date.now()

          if (response.data.data.length > 0) {
            context.contributionRepository.contributions.push(...response.data.data);
            for (const contribution of response.data.data) {
              context.onContributionCreated.dispatch({id: contribution.id});
            }
          }
        });
      }
    });
    setTimeout(context.checkForContribution, 1000, context);
  }
}

export class ContributionRepository implements IContributionRepository {
  public contributions: IContributionResponse[] = [];
constructor(private eventId:string) {
}
  public GetAllContributions(since:number/*options: IContributionRequestOptions*/): { toDate: Date; contributions: IContributionResponse[] } {
    // Axios.get(ApiRoutes.Contribution.GetAll.replace("{eventId}", this.eventId) + "?since=" + since).then((response: AxiosResponse<Response<IContributionResponse[]>>) => {
    //   if (response.data.data.length > 0) {
    //     this.contributions.push(...response.data.data);
    //     for (const contribution of response.data.data) {
    //       context.onContributionCreated.dispatch({id: contribution.id});
    //     }
    //   }
    // });
    return {contributions: this.contributions, toDate: new Date()};
  }

  public GetAllContributionsAsync(options: IContributionRequestOptions): Promise<{ toDate: Date; contributions: IContribution[] }> {
    return Promise.resolve({contributions: [], toDate: new Date(2020, 5, 1)});
  }

  public GetAllContributionsFromCurrentUser(options: IContributionRequestOptions): IContribution[] {
    return [];
  }

  public GetAllContributionsFromCurrentUserAsync(options: IContributionRequestOptions): Promise<IContribution[]> {
    return Promise.resolve([]);
  }

  public GetContributionById(id: string): IContributionResponse | null {
    return this.contributions.filter(c => c.id === id)[0] ?? null;
  }

  public GetContributionByIdAsync(id: string): Promise<IContribution | null> {
    return Promise.resolve(null);
  }

  public PostContribution(media: IMedia[]): boolean {
    return false;
  }

  public PostContributionAsync(media: IMedia[]): Promise<boolean> {
    return Promise.resolve(false);
  }


}

